import type { FunctionComponent } from 'react';

import { useGlobalSearchTableParams } from '../../../global-search/use-global-search-table-params';
import { SkillIdsTable } from './SkillIdTable';
import { SkillsSearchTermTable } from './SkillsSearchTermTable';

export const SkillsTable: FunctionComponent = () => {
    const { isValidSearchTerm, isValidSkillIdsList, searchTermResult, skillIds } = useGlobalSearchTableParams();

    if (isValidSkillIdsList) {
        return <SkillIdsTable skillIds={skillIds} />;
    }

    if (isValidSearchTerm) {
        return <SkillsSearchTermTable searchTerm={searchTermResult} />;
    }

    return null;
};
